export const TRANSFORMATION_TYPES = {
  MANUAL: 'Manually',
  AUOT: 'Automatically'
};
